var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"text-filed",attrs:{"label":_vm.label,"disabled":_vm.disabled,"rules":_vm.rules || [],"placeholder":_vm.placeholder || ' ',"type":_vm.type,"outlined":"","dense":""},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }